export var CommonEnum = {
  Yes: "Yes",
  No: "No",
  Allow: true,
  Y:"Y"
}

export var StatusCode = {
  OK: 200,
  Error: 505,
  failure: 500,
  Restricted: 403,
  partialContent: 206
}

export var CopyData = {
  CopyOf: "Copy of"
}

export var ListType = {
  List: 'List',
  Print: 'Print'
}

export var ExportType = {
  Excel: 'Excel',
  Word: 'Word'
}

export var AlignOrder = {
  Asc: 'Asc',
  Desc: 'Desc'
}

export enum SelectionType {
  Single = 1,
  Multiple = 2
}

export var DashboardStatistics = {
  JobsAwaitingApproval: 1,
  JobsAwaitingApprovalUrl: "/Search/Jobs",
  JobsAdvertised: 2,
  JobsAdvertisedUrl:"/Search/Jobs",
  LiveJobs: 3,
  LiveJobsUrl:"/Search/Jobs",
  NewApplications: 4,
  NewApplicationsUrl: "/Search/Candidates",
  InterviewsWithCalendar: 5,
  InterviewsWithCalendarUrl: "/Search/Candidates",
  InterviewsWithOutCalendar: 6,
  InterviewsWithOutCalendarUrl:"/Search/Candidates",
  CandidatescompletedvideoInterviews: 7,
  CandidatesCompleted2ndStage: 8,
  CandidatesCompleted2ndStageUrl: "/Search/Candidates",
  ApplicationOfferedRatio: 9,
  ApplicationOfferedRatioUrl:"/Search/Candidates",
  OfferedAcceptedRatio: 10,
  OfferedAcceptedRatioUrl: "/Search/Candidates",
  OnBoarding: 11,
  OnBoardingUrl: "/WorkPlace/MyStarter/List"
}

export var StatisticsUrl = {
  JobsAdvertised: 2,
  LiveJobs: 3,
  NewApplications: 4,
  InterviewsWithCalendar: 5,
  InterviewsWithOutCalendar: 6,
  CandidatescompletedvideoInterviews: 7,
  CandidatesCompleted2ndStage: 8,
  ApplicationOfferedRatio: 9,
  OfferedAcceptedRatio: 10,
  OnBoarding: 11
}

export var FilterKeys = {
  FDMListingType: "ListingType",
  ApplicationStatusId: "ApplicationStatusId",
  FDMTLSType: "TlsType",
  UserId: "UserId",
}
export var SSOType = {
  Microsoft: 'Microsoft',
  Cas: 'Cas'
}

